import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';

export interface Props {
  location: 'header' | 'footer';
}

const borderSide = (p: Props) => (p.location === 'header' ? 1 : -1);

const ActionsBarWrapper = styled.div`
  background: ${colors.grey50};
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  box-shadow: 0 ${borderSide}px 0 0 ${colors.grey100};

  .action-wrapper {
    margin: 0.25rem;
  }

  > * {
    margin: 0 0.5rem;
  }
`;

export default class ActionsBar extends React.Component<Props, {}> {
  render() {
    const { children } = this.props;

    return <ActionsBarWrapper {...this.props}>{children}</ActionsBarWrapper>;
  }
}
